import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=3dab57f6&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"
import style0 from "./Receipt.css?vue&type=style&index=0&id=3dab57f6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab57f6",
  null
  
)

export default component.exports